import React from "react";
import Popupz from "../atoms/Popupz";
import Buttonz from "../atoms/Buttonz";
import PropTypes from "prop-types";

const DeleteItemPopup = ({ item, onClose, onConfirm }) => {
  return (
    <Popupz
      title="Delete Item"
      text={
        <>
          Are you sure you want to delete item <strong>{item.name}</strong>?
          <br />
          This action cannot be undone.
        </>
      }
      onClose={onClose}
      popupId="delete-item"
      icon="warning"
      className="delete-confirmation"
    >
      <div className="popup-actions">
        <Buttonz label="Cancel" onClick={onClose} className="cancel-button" />
        <Buttonz
          label="Delete"
          onClick={onConfirm}
          className="delete-button danger"
          iconR="trash"
        />
      </div>
    </Popupz>
  );
};

DeleteItemPopup.propTypes = {
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteItemPopup;
